var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"blog-page faq-page"},[_c('Qna',{attrs:{"qna":_vm.qna,"categories":_vm.categories,"filter":_vm.filter,"page":_vm.page}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54ecb986","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/blog/Faq.vue
// module id = rsGp
// module chunks = 0